export const useStatamicPreview = (refresh: () => Promise<void>) => {
    onMounted(() => {
        window.onmessage = (event) => {
            if (event.data.name === 'statamic.preview.updated') {
                refresh()
            }
        }
    })
}
